import {fetchAllCustomers, fetchCustomerByEmail, saveCustomer} from '@/api/customer.api'
import Vue from 'vue'

const state = {
    fetchingCustomers: true,
    customers: [],
    currentCustomer: {},
    customerPageInfo: {
        currentPage: 0,
        pageSize: 10
    }
}

const getters = {
    isFetchingCustomers: state => state.fetchingCustomers,

    getCustomers: state => state.customers,

    getCurrentCustomer: state => state.currentCustomer,

    getCustomerByEmail: state => email => state.customers.find(c => c.email === email),

    getCustomerPageInfo: state => state.customerPageInfo
}

const actions = {
    async saveCustomerAndOrder({ dispatch, commit }, request) {
        await saveCustomer(request)
            .then(response => {
                commit('setCurrentCustomer', response.data)
                if (request.order)
                    dispatch('saveOrder', request.order)
            })
            .catch(error => {
                console.log(error)
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greške na serveru, molimo Vas pokušajte kasnije'
                })
            })
    },

    async pageCustomers({ commit }, { page, pageSize }) {
        commit('setFetchingCustomers', true)
        const response = await fetchAllCustomers(page, pageSize)
        commit('setCustomers', response.data.content)
        commit('setCustomerPageInfo', {
            currentPage: response.data.number,
            totalPages: response.data.totalPages,
            numberOfElements: response.data.numberOfElements,
            totalElements: response.data.totalElements,
            pageSize: response.data.size,
            isFirstPage: response.data.first,
            isLastPage: response.data.last
        })
        commit('setFetchingCustomers', false)
    },

    async fetchCustomerByEmail({ commit }, email) {
        const response = await fetchCustomerByEmail(email)
        commit('updateCustomer', response.data)
    }
}

const mutations = {
    setFetchingCustomers: (state, fetchingCustomers) => state.fetchingCutomers = fetchingCustomers,

    updateCustomer: (state, customer) => {
        const index = state.customers.findIndex(c => c.id === customer.id)
        if (index !== -1)
            state.customers.splice(index, 1, customer)
    },

    setCustomers: (state, customers) => state.customers = customers,

    setCurrentCustomer: (state, currentCustomer) => state.currentCustomer = currentCustomer,

    setCustomerPageInfo: (state, customerPageInfo) => state.customerPageInfo = customerPageInfo
}

export default {
    state,
    getters,
    actions,
    mutations
}
